import { z } from 'zod';

export const ErrorResponseSchema = z.object({
  error: z.string(),
  message: z.string(),
  status_code: z.number()
});
export type NwProductsExtensionsErrorResponseType = z.infer<
  typeof ErrorResponseSchema
>;

export const GetUserProgramSelectedChoicesRequestObjectSchema = z.object({
  program_id: z.number()
});
export type GetUserProgramSelectedChoicesRequestObjectType = z.infer<
  typeof GetUserProgramSelectedChoicesRequestObjectSchema
>;

export const InstituteChoiceProductDetailsSchema = z.object({
  product_code: z.string(),
  extra_info: z.string().optional()
});

export const SelectedChoiceSchema = z.object({
  id: z.string().uuid(),
  choice_type: z.enum(['INSTITUTE']),
  choice_name_enum: z.string(),
  institute_choice_products_details: z
    .array(InstituteChoiceProductDetailsSchema)
    .optional()
});

export const GetUserProgramSelectedChoicesResponseSchema = z.object({
  selected_choices: z.array(SelectedChoiceSchema)
});
export type GetUserProgramSelectedChoicesResponseType = z.infer<
  typeof GetUserProgramSelectedChoicesResponseSchema
>;

export const GetUserProgramSelectedChoicesBadRequestResponseSchema = z.object({
  response: z.string(),
  http_status_code: z.number(),
  res_status: z.enum(['INVALID_PROGRAM_ID'])
});
export type GetUserProgramSelectedChoicesBadRequestResponseType = z.infer<
  typeof GetUserProgramSelectedChoicesBadRequestResponseSchema
>;

export const CreateUserProgramSelectedChoiceRequestObjectSchema = z.object({
  program_id: z.number(),
  choice_type: z.enum(['INSTITUTE']),
  choice_name_enum: z.string()
});
export type CreateUserProgramSelectedChoiceRequestObjectType = z.infer<
  typeof CreateUserProgramSelectedChoiceRequestObjectSchema
>;

export const CreateUserProgramSelectedChoiceResponseSchema = z.object({
  message: z.string().optional()
});
export type CreateUserProgramSelectedChoiceResponseType = z.infer<
  typeof CreateUserProgramSelectedChoiceResponseSchema
>;

export const CreateUserProgramSelectedChoiceBadRequestResponseSchema = z.object(
  {
    response: z.string(),
    http_status_code: z.number(),
    res_status: z.enum([
      'INVALID_PROGRAM_ID',
      'INVALID_CHOICE_TYPE',
      'INVALID_CHOICE_NAME_ENUM'
    ])
  }
);
export type CreateUserProgramSelectedChoiceBadRequestResponseType = z.infer<
  typeof CreateUserProgramSelectedChoiceBadRequestResponseSchema
>;

export const CourseProductDetailSchema = z.object({
  product_code: z.string(),
  product_purpose: z.string().optional()
});

export const CourseItemDefinitionSchema = z.object({
  course_id: z.string().uuid(),
  course_name: z.string(),
  products_details: z.array(CourseProductDetailSchema)
});

export const InstituteWithCoursesDefinitionSchema = z.object({
  institute_id: z.string().uuid(),
  institute_name: z.string(),
  accommodation_modes: z.array(z.enum(['DAY_SCHOLAR', 'HOSTELER'])),
  courses: z.array(CourseItemDefinitionSchema)
});

export const GetAvailableProgramInstituteCoursesRequestObjectSchema = z.object({
  program_id: z.number()
});
export type GetAvailableProgramInstituteCoursesRequestObjectType = z.infer<
  typeof GetAvailableProgramInstituteCoursesRequestObjectSchema
>;

export const GetAvailableProgramInstituteCoursesResponseSchema = z.object({
  institutes: z.array(InstituteWithCoursesDefinitionSchema)
});
export type GetAvailableProgramInstituteCoursesResponseType = z.infer<
  typeof GetAvailableProgramInstituteCoursesResponseSchema
>;

export const GetProgramInstituteCoursesRequestObjectSchema = z.object({
  program_id: z.number(),
  institute_id: z.string().uuid()
});
export type GetProgramInstituteCoursesRequestObjectType = z.infer<
  typeof GetProgramInstituteCoursesRequestObjectSchema
>;

export const GetProgramInstituteCoursesResponseSchema = z.object({
  institute: InstituteWithCoursesDefinitionSchema
});
export type GetProgramInstituteCoursesResponseType = z.infer<
  typeof GetProgramInstituteCoursesResponseSchema
>;
